import {
  IconAccountTreeComponent,
  IconArrowRangeComponent,
  IconAttachMoneyComponent,
  IconCategoryComponent,
  IconCloudUploadComponent,
  IconDatabaseComponent,
  IconDataExplorationComponent,
  IconFlagComponent,
  IconFolderCopyComponent,
  IconHistoryComponent,
  IconLayersComponent,
  IconListAltComponent,
  IconMultilineChartComponent,
  IconPlayArrowComponent,
  IconPriceChangeComponent,
  IconRefreshComponent,
  IconRuleSettingsComponent,
  IconStackedLineChartComponent,
  IconVariablesComponent,
  IconWidgetsComponent,
} from '@risk-first/ui-assets';
import * as PageTitles from '../lib/constants/pageTitles';

export const getNavRoutes = () => {
  return [
    {
      page: 'Asset master and Entities',
      icon: IconAttachMoneyComponent,
      children: [
        {
          page: PageTitles.ASSET_MASTER,
          path: '/asset-master',
          icon: IconLayersComponent,
        },
        {
          page: PageTitles.ENTITIES,
          path: '/entities',
          icon: IconDatabaseComponent,
        },
        {
          page: PageTitles.ENTITY_MASTER,
          path: '/entity-master',
          icon: IconDatabaseComponent,
        },
      ],
    },
    {
      page: 'Valuations',
      icon: IconStackedLineChartComponent,
      children: [
        {
          page: PageTitles.PORTFOLIO_SETUP,
          path: '/portfolio-setup',
          icon: IconRuleSettingsComponent,
        },
        {
          page: PageTitles.PORTFOLIOS,
          path: '/portfolios',
          icon: IconFolderCopyComponent,
        },
        {
          page: PageTitles.VALUATION_RUNS,
          path: '/valuation-runs',
          icon: IconRefreshComponent,
        },
        {
          page: PageTitles.VALUATION_RANGE_RUNS,
          path: '/valuation-range-runs',
          icon: IconArrowRangeComponent,
        },
        {
          page: PageTitles.PRICING,
          path: '/pricing',
          icon: IconPriceChangeComponent,
        },
        {
          page: PageTitles.MARKET_DATA_REPORT,
          path: '/market-data-report',
          icon: IconHistoryComponent,
        },
      ],
    },
    {
      page: 'Market Data',
      icon: IconDataExplorationComponent,
      children: [
        {
          page: PageTitles.CURVES,
          path: '/curve-list',
          icon: IconMultilineChartComponent,
        },
        {
          page: PageTitles.INDEXES,
          path: '/indexes',
          icon: IconListAltComponent,
        },
      ],
    },
    {
      page: 'Data Import',
      icon: IconCloudUploadComponent,
      children: [
        {
          page: PageTitles.DATA_IMPORT_PIPELINES,
          path: '/data-import/pipelines',
          icon: IconAccountTreeComponent,
        },
        {
          page: PageTitles.DATA_IMPORT_RUNS,
          path: '/data-import/runs',
          icon: IconPlayArrowComponent,
        },
        {
          page: PageTitles.DATA_IMPORT_VARIABLE_SETS,
          path: '/data-import/variable-sets',
          icon: IconVariablesComponent,
        },
        {
          page: PageTitles.DATA_IMPORT_TASK_TYPES,
          path: '/data-import/task-types',
          icon: IconCategoryComponent,
        },
      ],
    },
    {
      page: 'Other',
      icon: IconWidgetsComponent,
      children: [
        {
          page: PageTitles.SPLIT_FLAGS,
          path: '/split-flags',
          icon: IconFlagComponent,
        },
      ],
    },
  ];
};
